<template>
    <section class="row">
        <div
            ref="gallery"
            :class="{ 'col-md-10 offset-md-1': width !== 'full' }"
            class="col-12 content-component content-component-gallery no-parallax position-relative"
            data-component="embeddedGallery"
        >
            <div
                class="content-component-body p-relative content-carousel-container"
                @mouseover="hoveringContainer = true"
                @mouseout="hoveringContainer = false"
            >
                <div class="js-content-carousel">
                    <div
                        v-for="(slide, key) in slides"
                        :key="slide.id"
                        class="cc-slide"
                    >
                        <figure>
                            <img
                                :src="slide.url"
                                :srcset="slide.responsiveImages"
                                class="img-fluid"
                                :alt="`${__('Image')}: ${slide.title} }}`"
                                :data-sub-html="getSubHtml(slide)"
                            >

                            <figcaption class="d-flex align-items-center justify-content-between gap-1">
                                <div
                                    v-if="slide.title"
                                    class="text-left"
                                >
                                    {{ slide.title }}
                                </div>
                                <div>
                                    {{ key + 1 }}/{{ slides.length }}
                                    <template v-if="slide.caption">
                                        : {{ slide.caption }}
                                    </template>
                                </div>
                            </figcaption>
                        </figure>
                    </div>
                </div>

                <svg class="icon icon-gallery">
                    <use xlink:href="#icon-gallery" />
                </svg>

                <div
                    :class="{ 'show': showPlayButton }"
                    class="position-absolute w-100 slick-play-button"
                >
                    <div
                        :class="{ 'pause': autoplay }"
                        class="toggle-slick-autoplay dark md"
                        role="button"
                        tabindex="0"
                        @click="toggleSlickAutoplay"
                    >
                        <div />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'EmbeddedGallery',

    props: {
        width: {
            type: String,
            default: 'full'
        },
        slides: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            hoveringContainer: false,
            isAccessible: false,

            lightGallery: null,

            slick: null,
            autoplay: true,
        }
    },

    computed: {
        showPlayButton() {
            return this.isAccessible || this.hoveringContainer
        }
    },

    created() {
        this.setAccessibility()
    },

    mounted() {
        this.initSlick()
    },

    methods: {
        setAccessibility() {
            const cookie = document.cookie

            this.isAccessible = cookie.includes('accessible=1')
        },

        getSubHtml(slide) {
            return `<div className=captionWrap>${this.getSubtitle(slide)}${this.getCaption(slide)}</div>`
        },

        getSubtitle(slide) {
            if (slide.title) {
                return `<h4 className=title>${slide.title}</h4>`
            }

            return ''
        },

        getCaption(slide) {
            if (slide.caption) {
                `<div className=text>${slide.caption}</div>`
            }

            return ''
        },

        initSlick() {
            // eslint-disable-next-line no-undef
            this.slick = $('.js-content-carousel:not(".slick-initialized")').slick({
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 320,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ],
                infinite: true,
                speed: 600,
                accessibility: this.isAccessible,
                autoplay: this.autoplay,
                autoplaySpeed: 16000,
                adaptiveHeight: true,
                fade: false,
                cssEase: 'ease-in',
                dots: true,
                lazyLoad: 'progressive',
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                // eslint-disable-next-line no-undef
                prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg class="icon icon-triangle-prev" arial-label="' + contentCarouselPrev + '"><use xlink:href="#triangle-prev"></use></svg></button>',
                // eslint-disable-next-line no-undef
                nextArrow: '<button type="button" class="slick-next slick-arrow"><svg class="icon icon-triangle-next" arial-label="' + contentCarouselNext + '"><use xlink:href="#triangle-next"></use></svg></button>',
            })
        },

        toggleSlickAutoplay() {
            this.slick.slick(this.autoplay ? 'slickPause': 'slickPlay')

            this.autoplay = ! this.autoplay
        }
    }
}
</script>

<style scoped>
    .toggle-slick-autoplay,
    .toggle-slick-autoplay div {
        transition-duration: 200ms;
    }
</style>
